import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { NavLink, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import {
  getInformationEntite,
  getListeSousEntite,
} from "../../services/entite/EntiteRequest";

const SousEntite = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
  });
  const [loadingData, setLoadingData] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [sousEntiteListe, setSousEntiteListe] = useState([]);
  const [appRoute, setAppRoute] = useState("");
  const [infoEntite, setInfoEntite] = useState("");

  const recupereListeDesEntites = () => {
    getListeSousEntite(pageQuery.page, 20)
      .then((res) => {
        setLoadingData(false);
        setSousEntiteListe(res.data.donnee);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient");
          navigate("/login");
        }
      });
  };

  useEffect(() => {
    setLoadingData(true);
    localStorage.removeItem("sousEntiteId");
    setAppRoute(
      localStorage.getItem("entiteRoute")
        ? localStorage.getItem("entiteRoute")
        : ""
    );

    const entite = localStorage.getItem("currentEntity")
      ? JSON.parse(localStorage.getItem("currentEntity"))
      : "";

    if (!entite) {
      getInformationEntite(
        localStorage.getItem("entiteRoute")
          ? localStorage.getItem("entiteRoute")
          : ""
      )
        .then((res) => {
          localStorage.setItem(
            "menuListSchool",
            JSON.stringify(res.data.donnee.menus)
          );
          localStorage.setItem("entiteSchool", res.data.donnee.designation);
          localStorage.setItem("entiteSchoolCode", res.data.donnee.code);
          localStorage.setItem("entiteRoute", res.data.donnee.entiteRoot);
          recupereListeDesEntites();
        })
        .catch((err) => {
          setLoadingData(false);
          console.log("api error", err);
          if (err.response && err.response.status === 401) {
            localStorage.removeItem("momo4scoohclient");
            navigate("/login");
          }
        });
    } else {
      recupereListeDesEntites();
    }
  }, []);

  return (
    <Layout>
      <div className="w-11/12 h-full mx-auto pt-32">
        <p className="text-3xl text-center font-bold">
          {localStorage.getItem("entiteSchoolCode") !== "SUPERMARKET"
            ? "Choisir un établissement pour continuer"
            : "Choisir un super marché pour continuer"}
        </p>

        <div className="w-10/12 mx-auto mt-16">
          {sousEntiteListe.length !== 0 && !loadingData ? (
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {sousEntiteListe.map((item, index) => (
                <div
                  onClick={() => localStorage.setItem("sousEntiteId", item.id)}
                >
                  <NavLink to={`/${appRoute}/entite/dashboard`}>
                    {/* <NavLink to={"/" + item.lien}> */}
                    <div className="flex items-center justify-center bg-white w-64 h-40 mx-auto rounded-lg shadow p-3 cursor-pointer">
                      <p className="text-xl text-center font-bold">
                        {item.nom}
                      </p>
                    </div>
                  </NavLink>
                </div>
              ))}
            </div>
          ) : sousEntiteListe.length === 0 && loadingData ? (
            <div className="w-80 mx-auto h-16 rounded-md bg-white flex items-center justify-center">
              <p className="text-lg text-gray-800 font-bold">Chargement...</p>
            </div>
          ) : null}

          {sousEntiteListe.length === 0 && !loadingData ? (
            <div className="w-80 mx-auto h-16 rounded-md bg-red-100 flex items-center justify-center">
              <p className="text-lg text-red-800 font-bold">
                {localStorage.getItem("entiteSchoolCode") !== "SUPERMARKET"
                  ? "Aucun établissement trouvé"
                  : "Aucun super marché trouvé"}
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </Layout>
  );
};

export default SousEntite;
